import React from "react";
import { ExpendableLink } from "./expendable-link";
import {
  Blocks,
  LayoutDashboard,
  User,
  Building2,
  Contact2,
  Megaphone,
  Mail,
  Settings,
  Layers,
  FileText,
  Newspaper,
  Compass,
  Palette,
  Puzzle,
  Globe,
  Target,
  ListChecks,
  Lightbulb,
} from "lucide-react";

export const AdminMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={18} />}
      />

      <ExpendableLink
        title="Prospects"
        url="/prospects"
        icon={<Target size={18} />}
      />

      <ExpendableLink
        title="Clients"
        url="/customers"
        icon={<Building2 size={18} />}
      />

      <ExpendableLink
        title="Utilisateurs"
        url="/users"
        icon={<User size={18} />}
      />
      <ExpendableLink
        icon={<Blocks size={18} />}
        title="Categories"
        url="/categories"
      />

      <ExpendableLink
        title="Contacts"
        url="/contacts"
        icon={<Contact2 size={18} />}
      />

      <ExpendableLink
        title="Prospections"
        url="/prospections"
        icon={<Megaphone size={18} />}
      />

      <ExpendableLink
        title="Tâches"
        url="/customer-tasks"
        icon={<ListChecks size={18} />}
      />

      <ExpendableLink
        title="Aide à la vente"
        url="/sales-arguments"
        icon={<Lightbulb size={18} />}
      />

      <ExpendableLink
        title="Rapports SEO"
        url="/reports"
        icon={<FileText size={18} />}
      />

      <ExpendableLink
        title="Articles"
        url="/articles"
        icon={<Newspaper size={18} />}
      />

      <ExpendableLink
        title="CMS"
        url="/cms"
        icon={<Layers size={18} />}
      />

      <ExpendableLink
        title="Sites générés"
        url="/created-sites"
        icon={<Globe size={18} />}
      />

      <ExpendableLink
        title="Thèmes"
        url="/themes"
        icon={<Palette size={18} />}
      />

      <ExpendableLink
        title="Fragments de prompt"
        url="/prompt-fragments"
        icon={<Puzzle size={18} />}
      />

      <ExpendableLink
        title="Emails"
        url="/mail-messages"
        icon={<Mail size={18} />}
      />

      <ExpendableLink
        title="Ma boite mail"
        url="/my-mailbox"
        icon={<Settings size={18} />}
      />

      <ExpendableLink
        title="Tuto"
        url="/tuto"
        icon={<Compass size={18} />}
      />
    </>
  );
};
